<template>
    <el-dialog :title="titleVale" v-model="dialogVisible" width="30%" :before-close="handleClose">
        <el-form :model="form" :rules="rules" ref="ruleForm">
            <el-form-item label="标题:" prop="title" label-width="100px">
                <el-input v-model="form.title" autocomplete="off"></el-input>
            </el-form-item>
            <!-- <el-form-item label="所属用户:" prop="userName" label-width="100px">
                <el-input v-model="form.userName" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="发布时间:" prop="addTime" label-width="100px">
                <el-date-picker
                    v-model="form.addTime"
                    type="datetime"
                    placeholder="选择日期时间">
                </el-date-picker>
            </el-form-item> -->
            <el-form-item label="内容:" prop="textValue" label-width="100px">
                <el-input type="textarea" v-model="form.textValue" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="年级" prop="classes" label-width="100px">
                <el-select filterable v-model="form.classes" placeholder="请选择年级" @change="classClick">
                    <el-option :label="item.name" :value="item.id" v-for="item in gradeDataList" :key="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="班级" prop="classes2" label-width="100px">
                <el-select filterable v-model="form.classes2" placeholder="请选择班级">
                    <el-option :label="item.name" :value="item.id" v-for="item in classList" :key="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="作业类型:" prop="type" label-width="100px">
                <el-select filterable v-model="form.type" placeholder="请选择">
                    <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="发布时间" label-width="100px">
                    <el-date-picker
                        v-model="form.fabushijian"
                        type="datetime"
                        format="YYYY-MM-DD HH:mm:ss"
                        value-format="YYYY-MM-DD HH:mm:ss"
                        placeholder="选择日期时间">
                    </el-date-picker>
                </el-form-item>
            <el-form-item label="完成时间" label-width="100px">
                    <el-date-picker
                        v-model="form.finishTime"
                        type="datetime"
                        format="YYYY-MM-DD HH:mm:ss"
                        value-format="YYYY-MM-DD HH:mm:ss"
                        placeholder="选择日期时间">
                    </el-date-picker>
                </el-form-item>
            <el-form-item label="上传:" prop="shangchuan" label-width="100px" v-show="!fileShow ">
                <span @click="shangchuan">{{ this.tempFile }}</span>
            </el-form-item>
            <el-form-item v-show="fileShow" label="上传:" prop="shangchuan" label-width="100px">
                <input 
                ref="inputFile" 
                class="upload" 
                style="cursor: pointer;" 
                id="inputFile" 
                type="file" 
                @change="getFile($event)"
                @click="chufa"
                />
            </el-form-item>
            
            <div class="buttom-box">
                <el-button type="primary" class="Tijiao" @click="submitForm('ruleForm')">提交</el-button>
                <el-button @click="handleClose">返回</el-button>
            </div>
        </el-form>

    </el-dialog>
</template>
<script>
import { subjectList,homeworkPublish,uploadImage,noticeUpdate} from '@/assets/api/schoollog'
import { gradeList, findClassList } from '@/assets/api/renyuan';
// import { ElMessage } from 'element-plus'

export default {
    components: {
    },
    props: ['reviseItem','objLookTeacher'],
    data() {

        return {

            dialogVisible: true,
            title: '',
            form: {
                type: '',
                userName: '',
                addTime: '',
                textValue: '',
                shangchuan: '',
                title: '',
                classes: '',
                classes2: '',
                finishTime: '',
                fabushijian: '',
            },
            cardid: "",
            schoolList: [],
            titleVale: '',
            options: [],
            rules: {
                type: [
                    { required: true, message: '请选择类型', trigger: 'change' }
                ],
                userName: [
                    { required: true, message: '请选择所属用户', trigger: 'change' }
                ],
                addTime: [
                    { required: true, message: '发布时间', trigger: 'change' }
                ],
                textValue: [
                    { required: true, message: '发布文本内容', trigger: 'change' }
                ],
                title: [
                    { required: true, message: '标题', trigger: 'change' }
                ],
            },
            tempFile: '',
            picImage:'',
            fileShow: true,
            classList: [],
            gradeDataList: [],
        }
    },
    created() {
        this.schoolClick()
		this.getSubject();
        if ( JSON.stringify(this.reviseItem) != '{}' ) {
            this.titleVale = '修改信息'
            let data = JSON.parse(this.reviseItem.content)
            this.form.title = data.title
            this.form.textValue = data.content
            this.form.type = data.type
            this.form.classes = data.gradeId 

            let params = {
                page: '1',
                pageSize: '999',
            }
            findClassList(params, this.form.classes).then((res) => {
                this.classList = res.data.data.list
                this.form.classes2 = data.classId
                console.log(res, '班级列表',this.form.classes2);
            }).catch((err) => {
                console.log(err);
            })
            this.form.finishTime = this.reviseItem.finished
            this.form.fabushijian = this.reviseItem.created
            this.picImage = data.pic || ''
            this.tempFile = data.pic? data.pic.slice(data.pic.lastIndexOf('/') + 1):''
            // this.picImage = data.pic
            // this.tempFile = data.pic.slice(data.pic.lastIndexOf('/') + 1);
            this.fileShow = false
            console.log(JSON.parse(this.reviseItem.content),this.tempFile);

            
        } else {
            this.titleVale = '发布作业'
        }
    },
    mounted() {
        console.log(this.objLookTeacher);
    },
    methods: {
        chufa () {
            console.log('测试4556');
        },
        shangchuan () {
            // this.$refs.inputFile.getFile($event)
            document.getElementById("inputFile").click();
            console.log(document.getElementById("inputFile"));
            // this.$refs.inputFile.click()
        },
        getFile(event) {
            this.fileShow = true    
            this.tempFile = event.target.files[0];
            let index = this.tempFile.name.lastIndexOf(".");
            let fileName = this.tempFile.name.substr(index + 1);
            var filetypes = [
                "jpg",
                "png",
                "gif",
                "jpeg",
                "doc",
                "ppt",
                "xls",
                "pdf",
                "docx",
                "xlsx",
            ];
            if (filetypes.includes(fileName)) {
                if (this.tempFile) {
                    let fileSize = this.tempFile.size / (1024 * 1024 * 60);
                    if (this.tempFile.name) {
                        let formData = new FormData();
                        console.log(formData, 8888888);
                        formData.append("file", this.tempFile);
                        console.log(this.tempFile, formData.getAll('file'),this.tempFile.name);
                 
                        uploadImage(formData,this.tempFile.name).then((res) => {
                            console.log(res);
                            this.picImage = res.data.data.picImage
                            // ElMessage({ message: '', type: 'success', })
                            this.$message({
                                message: '上传文件成功！',
                                type: 'success'
                            });
                        }).catch((err) => {
                            // console.log();
                            ElMessage.error("上传失败")
                        })


                    }
                }
            } else {
                ElMessage.error("请上传jpg,png,gif,jpeg,doc,ppt,xls,pdf,docx,xlsx格式的文件!")
            }
        },
        handleClose() {
            this.$emit('backClick')
        },
        submitForm(ruleForm) {
            this.$refs[ruleForm].validate((valid) => {
                if (valid) {
                    // alert('submit!');
                    this.addClick()
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        addClick() {
            console.log('提交');
            if ( JSON.stringify(this.reviseItem) != '{}' ) {
                let params = {
                    classId: this.form.classes2,
                    content: this.form.textValue,
                    finishTime: this.form.finishTime,
                    gradeId: this.form.classes,
                    pic: this.picImage,
                    publisherId: JSON.parse(localStorage.getItem('user')).id,
                    schoolId: this.objLookTeacher.schoolId,
                    title : this.form.title,
                    type : this.form.type,
                    homeworkId: this.reviseItem.id
                }
                homeworkPublish(params ).then((res) => {
                    console.log(res);
                    this.$message({
                        message: '发布信息成功！',
                        type: 'success'
                    });
                    this.handleClose()
                }).catch((err) => {
                    this.$message.error('发布信息失败');
                })
            } else {
                let params = {
                    classId: this.form.classes2,
                    content: this.form.textValue,
                    finishTime: this.form.finishTime,
                    gradeId: this.form.classes,
                    pic: this.picImage,
                    publisherId: JSON.parse(localStorage.getItem('user')).id,
                    schoolId: this.objLookTeacher.schoolId,
                    title : this.form.title,
                    type : this.form.type,
                }
                homeworkPublish(params ).then((res) => {
                    console.log(res);
                    this.$message({
                        message: '发布信息成功！',
                        type: 'success'
                    });
                    this.handleClose()
                }).catch((err) => {
                    // this.$message.error('发布信息失败');
                    this.$message({
                    type: 'error',
                    message: err.response.data.msg
                });
                })
            }

        },
        schoolClick() {
        this.form.classes = ''
        this.form.classes2 = ''
        let params = {
          page: '1',
          pageSize: '999',
        }
        gradeList(params, this.objLookTeacher.schoolId).then((res) => {
          console.log(res, '年级列表');
          this.gradeDataList = res.data.data;
        }).catch((err) => {
          console.log(err);
        })
      },
	  
	  getSubject(){
		  let params = {
		  	schoolId: this.objLookTeacher.schoolId,
		  }

		  subjectList(params).then((res) => {
		  	console.log(res, '列表');
		  	this.options = res.data.data;
		  }).catch((err) => {
		  	console.log(err, 444);
		  })
	  },
	  
      classClick() {
        this.form.classes2 = ''
        let params = {
          page: '1',
          pageSize: '999',
        }
        findClassList(params, this.form.classes).then((res) => {
          console.log(res, '班级列表');
          this.classList = res.data.data;
        }).catch((err) => {
          console.log(err);
        })
      },
    }
}




</script>
<style  scoped lang="scss">
.Tijiao {
    // background-color: #1BC896;
}

/deep/ {
    .el-input--small .el-input__wrapper {
        height: 35px;
        line-height: 35px;
        text-align: center;
        width: 280px;
    }

    .el-input__inner {
        // width: 10px !important;
    }

    .buttom-box {
        // text-align: center;
        margin-left: 180px;

    }

    .el-form-item--small {
        width: 70% !important;
    }

    .el-button--small {
        width: 60px !important;
        height: 35px !important;
        // color: #1BC896;


    }
    .el-select--small .el-select__wrapper {
        height: 35px;
    }
    .el-form-item--small .el-form-item__label {
        height: 35px;
        line-height: 35px;
    }
}
</style>